import { render, staticRenderFns } from "./user-wallet.vue?vue&type=template&id=0cb5e30c&scoped=true"
import script from "./user-wallet.vue?vue&type=script&lang=js"
export * from "./user-wallet.vue?vue&type=script&lang=js"
import style0 from "./user-wallet.vue?vue&type=style&index=0&id=0cb5e30c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb5e30c",
  null
  
)

export default component.exports